import React, { ReactElement } from "react"
import { useLocation } from "react-router-dom"
import { getEmployeeAllCarrotPlansLink } from "./utils/navigationUtils"
import { Box, Button } from "@carrotfertility/carotene-core"

export default function EmployeeButtonBar({ employeeId }: { employeeId: string }): ReactElement {
  const location = useLocation()
  const allPlansPath = getEmployeeAllCarrotPlansLink(`${employeeId}`)
  const onAllPlans = location.pathname === allPlansPath

  return (
    !onAllPlans && (
      <Box display="flex" justifyContent="left" paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}>
        <Button href={allPlansPath} variant="outlined">
          All Carrot Plans
        </Button>
      </Box>
    )
  )
}
